export default __webpack_public_path__ + "static/APFIPP_logo-4cc5139210fa67dd1adad101cfd66cb3.png";